import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/memories-banner.webp";

const PhotoMemoriesModal = ({ serialNumber, onClose }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Photo Memories"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>
              {
                "To remember your time and all the priceless moments at the UEFA Champions League Final in Budapest, download your photos here."
              }
            </p>
          </div>
          <div className="section bg-black">
            <p className="bold">{"Memories Gallery"}</p>
            <div className="group btn-group">
              <div
                className="button"
                onClick={() => {
                  window.open(
                    `https://memento.photo/j/uotbKSLY?eat=${serialNumber}`,
                    "_blank"
                  );
                }}
              >
                <p>{"View Memories"}</p>
              </div>
         
            </div>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default PhotoMemoriesModal;
